// Human-readable labels for audit_log.action (identity spec §3.9). The raw
// action is kept on the element's title attribute so operators can still grep
// for the exact value when debugging.
const AUDIT_ACTION_LABELS: Record<string, string> = {
  'costs.updated': 'Costs published',
  'costs.deleted': 'Costs month removed',
  'device_link.created': 'Device link made',
  'family.created': 'Family created',
  'family.updated': 'Family updated',
  'family.deleted': 'Family deleted',
  'message.deleted': 'Message deleted by an admin',
  'enrollment_token.created': 'Enrollment link created',
  'enrollment_token.revoked': 'Enrollment link revoked',
  'enrollment_token.regenerated': 'Enrollment link regenerated',
  'enrollment.completed': 'Enrollment completed',
  'device.added': 'Device added',
  'device.renamed': 'Device renamed',
  'device.revoked': 'Device revoked',
  'session.revoked': 'Signed out a session',
  'session.reuse_detected': 'Refresh token reused; session signed out',
  'lawful_request.exported': 'Sign-in log exported for a legal request',
  'invite.created': 'Invitation sent',
  'invite.accepted': 'Invitation accepted',
  'invite.declined': 'Invitation declined',
  'member.role_changed': 'Member role changed',
  'member.updated': 'Member updated',
  'member.left': 'Member left',
  'member.removed': 'Member removed',
  'user.deleted': 'User deleted',
  'admin.family_route_access': 'System root accessed family',
  'review_family.created': 'Review family created',
  'review_member.created': 'Demo member added',
  'review_link.created': 'Review link made',
  'review_link.opened': 'Review link opened',
  'review_link.revoked': 'Review link revoked',
};

const fallbackLabel = (action: string) =>
  action
    .split(/[._]/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export function auditActionLabel(action: string): string {
  return AUDIT_ACTION_LABELS[action] ?? fallbackLabel(action);
}
